import { useMediaQuery } from 'usehooks-ts';

const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT}px)`);
}
